export * from './auth';
export * from './auth_backend';
export * from './firebase_sdk_auth_backend';
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
